import request from '../util/request.js'


// tech/class/course/helperEvaluate




//删除学生档案
export function personalFileRemove(id) {
	return request({
		method: 'post',
		url: `tech/class/student/personalFile/remove/${id}`,
	})
}


//删除日常记录
export function dailyRecordRemove(id) {
	return request({
		method: 'post',
		url: `tech/class/student/dailyRecord/remove/${id}`,
	})
}

//获取学生档案列表
export function studentPersonalFileList(studentId,pageNum,pageSize,keywords,startDate,endDate) {
	return request({
		method: 'get',
		url: `tech/class/student/personalFile/list/${studentId}?pageNum=${pageNum}&pageSize=${pageSize}&keywords=${keywords}&startDate=${startDate}&endDate=${endDate}`,
	})
}



//新增学生档案
export function studentPersonalFileAdd(data) {
	return request({
		method: 'post',
		url: `tech/class/student/personalFile/add`,
		data
	})
}

//获取智能体评价列表
export function classHelperStudentList(studentId,pageNum,pageSize,keywords,startDate,endDate) {
	return request({
		method: 'get',
		url: `tech/class/student/dailyRecord/classHelperStudentList/${studentId}?pageNum=${pageNum}&pageSize=${pageSize}&keywords=${keywords}&startDate=${startDate}&endDate=${endDate}`,
	})
}


//获取日常记录列表
export function dailyRecordList(studentId,pageNum,pageSize,source,keywords,startDate,endDate) {
	return request({
		method: 'get',
		url: `tech/class/student/dailyRecord/list/${studentId}?pageNum=${pageNum}&pageSize=${pageSize}&source=${source}&keywords=${keywords}&startDate=${startDate}&endDate=${endDate}`,
	})
}

//获取班级学生列表
export function dailyRecordListStudent(classId,studentName) {
	return request({
		method: 'get',
		url: `tech/class/student/dailyRecord/listStudent/${classId}?studentName=${studentName}`,
	})
}


//出题助手回答列表
export function studentQuestionList(techClassHelperId,questionId) {
	return request({
		method: 'get',
		url: `tech/class/course/studentQuestionList?techClassHelperId=${techClassHelperId}&questionId=${questionId}`,
	})
}


//出题助手统计
export function questionHelperStatistics(techClassHelperId) {
	return request({
		method: 'get',
		url: `tech/class/course/questionHelperStatistics?techClassHelperId=${techClassHelperId}`,
	})
}

//修改题目分组
export function editQuestionGroup(data) {
	return request({
		method: 'post',
		url: `bot/editQuestionGroup`,
		data
	})
}

//删除题目分组
export function deleteQuestionGroup(id) {
	return request({
		method: 'post',
		url: `bot/deleteQuestionGroup?id=${id}`
	})
}

//修改题目
export function editQuestion(data) {
	return request({
		method: 'post',
		url: `bot/editQuestion`,
		data
	})
}

//删除题目
export function deleteQuestion(questionGroupId,questionId) {
	return request({
		method: 'get',
		url: `bot/deleteQuestion?questionGroupId=${questionGroupId}&questionId=${questionId}`,
	})
}

//修改题目状态
export function editQuestionStatus(questionGroupId,questionId,status) {
	return request({
		method: 'get',
		url: `bot/editQuestionStatus?questionGroupId=${questionGroupId}&questionId=${questionId}&status=${status}`,
	})
}

//修改题目序号
export function editQuestionSort(questionGroupId,questionId,sort) {
	return request({
		method: 'get',
		url: `bot/editQuestionSort?questionGroupId=${questionGroupId}&questionId=${questionId}&sort=${sort}`,
	})
}

//分组下题目列表
export function questionGroupQuestionList(id,pageNum,pageSize) {
	return request({
		method: 'get',
		url: `bot/getQuestionGroupQuestionList?id=${id}&pageNum=${pageNum}&pageSize=${pageSize}`,
	})
}

//新增题目
export function addQuestion(data) {
	return request({
		method: 'post',
		url: `bot/addQuestion`,
		data
	})
}

//题目分组详情
export function detailQuestionGroup(id) {
	return request({
		method: 'post',
		url: `bot/detailQuestionGroup?id=${id}`
	})
}

//题目分组列表
export function questionGroupList(pageNum,pageSize) {
	return request({
		method: 'get',
		url: `bot/getQuestionGroupList?pageNum=${pageNum}&pageSize=${pageSize}`,
	})
}

//新增题目分组
export function addQuestionGroup(data) {
	return request({
		method: 'post',
		url: `bot/addQuestionGroup`,
		data
	})
}

//每次进入助手创建会话
export function classroomTestCreateSessionStu(techClassHelperId) {
	return request({
		method: 'post',
		url: `classroomTest/createSession?techClassHelperId=${techClassHelperId}`
	})
}

//判断智能体开关状态 0-使用中 1-完成 2-未使用
export function classroomTestStatusStu(helperId) {
	return request({
		method: 'post',
		url: `classroomTest/getStatus?helperId=${helperId}`
	})
}

//课堂测试助手列表
export function classroomTestList() {
	return request({
		method: 'get',
		url: `classroomTest/list`
	})
}

//学生登录
export function classroomTestLogin(data) {
	return request({
		method: 'post',
		url: `classroomTest/login`,
		data
	})
}

//每次进入助手创建会话
export function classroomTestCreateSession(techClassHelperId) {
	return request({
		method: 'post',
		url: `teacherTerminal/createSession?techClassHelperId=${techClassHelperId}`
	})
}


//判断智能体开关状态 0-使用中 1-完成 2-未使用
export function classroomTestStatus(helperId) {
	return request({
		method: 'post',
		url: `teacherTerminal/getStatus?helperId=${helperId}`
	})
}

//课堂测试助手列表
export function teacherTerminalList() {
	return request({
		method: 'get',
		url: `teacherTerminal/list`
	})
}


//导入教研组账号模板下载
export function importTemplateJY() {
	return request({
		method: 'post',
		url: `tech/class/student/importTemplateJY`
	})
}


//新增教研组账号
export function addForJY(data) {
	return request({
		method: 'post',
		url: `tech/class/student/addForJY`,
		data
	})
}

//教研端登录
export function teachingResearchLogin(data) {
	return request({
		method: 'post',
		url: `teacherTerminal/loginForAccount`,
		data
	})
}

//复制智能体
export function botCopy(id) {
	return request({
		method: 'post',
		url: `bot/copy?id=${id}`
	})
}


//删除智能体
export function botDelete(id) {
	return request({
		method: 'post',
		url: `bot/delete?id=${id}`
	})
}


//解散班级
export function classDissolve(classId) {
	return request({
		method: 'get',
		url: `tech/class/dissolve/${classId}`,
	})
}

//移除班级学生
export function studentRemove(data) {
	return request({
		method: 'post',
		url: `tech/class/student/remove`,
		data
	})
}

//新增体验课堂
export function experienceClassroomAdd(data) {
	return request({
		method: 'post',
		url: `experienceClassroom/add`,
		data
	})
}

//体验课堂模板列表
export function experienceClassroomTemplateList(pageNum,courseType,isTeacher) {
	return request({
		method: 'get',
		url: `experienceClassroom/templateList`,
	})
}


//体验课堂列表
export function experienceClassroomList(pageNum,courseType,isTeacher) {
	return request({
		method: 'get',
		url: `experienceClassroom/list?pageNum=${pageNum}&pageSize=${20}&courseType=${courseType||''}&isTeacher=${isTeacher==1?true:false}`,
	})
}

export function updateStudentPause(techClassHelperId,studentId,ifPause) {
	return request({
		method: 'get',
		url: `tech/class/course/updateStudentPause?techClassHelperId=${techClassHelperId}&studentId=${studentId}&ifPause=${ifPause}`,
	})
}

export function updateHelperPause(techClassHelperId,ifPause) {
	return request({
		method: 'get',
		url: `tech/class/course/updateHelperPause?techClassHelperId=${techClassHelperId}&ifPause=${ifPause}`,
	})
}

export function promptHelperSessionDelete(sessionId) {
	return request({
		method: 'post',
		url: `promptHelper/promptHelperSessionDelete?sessionId=${sessionId}`,
	})
}

export function promptHelperSessionList(pageNum, pageSize, helperId) {
	return request({
		method: 'post',
		url: `promptHelper/promptHelperSessionList?pageNum=${pageNum}&pageSize=${pageSize}&helperId=${helperId}`,
	})
}

export function downloadSessionMsg(msgId) {
	return request({
		method: 'post',
		url: `helper/downloadSessionMsg?msgId=${msgId}`,
	})
}

export function presetHelperSessionList(helperId,pageNum,pageSize) {
	return request({
		method: 'post',
		url: `presetHelper/presetHelperSessionList?helperId=${helperId}&pageNum=${pageNum}&pageSize=${pageSize}`,
	})
}

//班级列表
export function schoolCourseList(pageNum,pageSize,data) {
	return request({
		method: 'post',
		url: `school/courseList?pageNum=${pageNum}&pageSize=${pageSize}`,
		data
	})
}

//班级列表
export function schoolClassList(pageNum,pageSize,data) {
	return request({
		method: 'post',
		url: `school/classList?pageNum=${pageNum}&pageSize=${pageSize}`,
		data
	})
}

//移动资源文件
export function fileResourceMove(data) {
	return request({
		method: 'post',
		url: `file/fileResource/move`,
		data
	})
}


//资源文件转存
export function transferResource(data) {
	return request({
		method: 'post',
		url: `file/fileResource/transferResource`,
		data
	})
}


//添加账号
export function schoolUserAdd(data) {
	return request({
		method: 'post',
		url: `school/userAdd`,
		data
	})
}

//删除资源文件
export function fileResourceRemove(ids) {
	return request({
		method: 'post',
		url: `file/fileResource/${ids}`,
	})
}

//获取资源文件详细信息
export function fileResourceInfo(id) {
	return request({
		method: 'get',
		url: `file/fileResource/get/${id}`
	})
}

//资源文件笔记链接修改
export function editResource(data) {
	return request({
		method: 'post',
		url: `file/fileResource/upResource`,
		data
	})
}

//获取资源文件AI分析报告内容
export function aiAnalysis(id) {
	return request({
		method: 'get',
		url: `file/fileResource/getAiAnalysis/${id}`
	})
}

//新增个人资源文件
export function fileResourceAdd(data) {
	return request({
		method: 'post',
		url: `file/fileResource/add`,
		data
	})
}


//查询资源文件列表
export function fileResourceList(keyword,parentId,resourceType,sort,sortType,type) {
	return request({
		method: 'get',
		url: `file/fileResource/list?keyword=${keyword?keyword:''}&parentId=${parentId?parentId:''}&resourceType=${resourceType?resourceType:''}&sort=${sort?sort:''}&sortType=${sortType?sortType:''}&type=${type?type:''}
`
	})
}

// 解除绑定
export function schoolUserUnbind(userId) {
	return request({
		method: 'get',
		url: `school/userUnbind?userId=${userId}`,
	})
}

// 学校老师账号列表
export function schoolUserList(pageNum,pageSize,data) {
	return request({
		method: 'post',
		url: `school/userList?pageNum=${pageNum}&pageSize=${pageSize}`,
		data
	})
}

//学校账号信息
export function infoSchool(data) {
	return request({
		method: 'post',
		url: `school/infoSchool`,
		data
	})
}

//课堂助手设置
export function courseHelperSet(data) {
	return request({
		method: 'post',
		url: `tech/class/course/helperSet`,
		data
	})
}

export function topEvaluateTypeOption(courseType) {
	return request({
		method: 'post',
		url: `bot/topEvaluateTypeOption?courseType=${courseType}`,
	})
}



// 选择知识点
export function knowledgePointsOption(techSubjectId) {
	return request({
		method: 'post',
		url: `bot/knowledgePointsOption?techSubjectId=${techSubjectId}`,
	})
}


//获取默认提示词
export function defaultPrompt(data) {
	return request({
		method: 'post',
		url: `bot/getPrompt`,
		data
	})
}

//获取默认评价维度
export function defaultEvaluate(data) {
	return request({
		method: 'post',
		url: `bot/getEvaluateType`,
		data
	})
}


// 获取下级下拉列表
export function childrenList(id) {
	return request({
		method: 'get',
		url: `tech/sectionSubject/childrenList/${id}`,
	})
}


// 选择目标
export function targetOption(techSubjectId) {
	return request({
		method: 'post',
		url: `bot/targetOption?techSubjectId=${techSubjectId}`,
	})
}

export function evaluateTypeDelete(id) {
	return request({
		method: 'post',
		url: `bot/evaluateTypeDelete?id=${id}`,
	})
}

//课堂点评记录列表
export function courseCommentList(techCourseId, pageNum) {
	return request({
		method: 'get',
		url: `tech/class/course/courseCommentList?techCourseId=${techCourseId}&pageNum=${pageNum}&pageSize=${20}`,
	})
}


//新建维度
export function evaluateTypeAdd(data) {
	return request({
		method: 'post',
		url: `bot/evaluateTypeAdd`,
		data
	})
}

//查询课堂维度选择列表
export function evaluateTypeOption(courseType,ifPerson) {
	return request({
		method: 'get',
		url: `bot/evaluateTypeOption?courseType=${courseType}&ifPerson=${ifPerson?ifPerson:''}`,
	})
}

//
export function verifyTableFormatForJY(data) {
	return request({
		method: 'post',
		url: `tech/class/student/verifyTableFormatForJY`,
		data
	})
}

//
export function verifyTableFormat(data) {
	return request({
		method: 'post',
		url: `tech/class/student/verifyTableFormat`,
		data
	})
}

//同声传译提交
export function saveNew(data) {
	return request({
		method: 'post',
		url: `trans/transRecord/saveNew`,
		data
	})
}

//提示词优化
export function promptEvolve(data) {
	return request({
		method: 'post',
		url: `bot/promptEvolve`,
		data
	})
}

//通用助手会话列表删除
export function universalHelperSessionDelete(id) {
	return request({
		method: 'get',
		url: `universalHelper/universalHelperSessionDelete/${id}`,
	})
}

//通用助手会话列表重命名
export function universalHelperSessionRename(data) {
	return request({
		method: 'post',
		url: `universalHelper/universalHelperSessionRename`,
		data
	})
}

//通用助手历史记录
export function universalHelperSessionList(pageNum) {
	return request({
		method: 'post',
		url: `universalHelper/universalHelperSessionList?pageNum=${pageNum}&pageSize=${20}`,
	})
}


//获取智能体详情
export function teacherTerminalTestInfo(id, sessionId) {
	return request({
		method: 'get',
		url: `teacherTerminal/get/${id}/${sessionId}`,
	})
}


//获取智能体详情
export function classroomTestInfo(id, sessionId) {
	return request({
		method: 'get',
		url: `classroomTest/get/${id}/${sessionId}`,
	})
}

//修改智能体
export function botUpdate(data) {
	return request({
		method: 'post',
		url: `bot/update`,
		data
	})
}

//获取智能体详情
export function botInfo(botId) {
	return request({
		method: 'get',
		url: `bot/info?id=${botId}`,
	})
}

//根据sessionId获取会话详情列表
export function helperMsgDetailList(sessionId) {
	return request({
		method: 'post',
		url:`promptHelper/getHelperMsgDetailList?sessionId=${sessionId}`,
	})
}



//获取智能体列表
export function botList(type,courseType,isTeacher) {
	return request({
		method: 'get',
		url: `bot/list?type=${type}&courseType=${courseType}&isTeacher=${isTeacher==1?true:false}`,
	})
}

//创建智能体
export function botCreate(data) {
	return request({
		method: 'post',
		url: `bot/create`,
		data
	})
}

//首次完善个人信息
export function completeUserInfo(data) {
	return request({
		method: 'post',
		url: `user/info/complete`,
		data
	})
}


//根据学段id获取任教职务列表
export function techPostListBySectionId(sectionId) {
	return request({
		method: 'get',
		url: `tech/sectionSubject/techPostListBySectionId/${sectionId}`,
	})
}

//地区列表
export function areaCascaderList() {
	return request({
		method: 'get',
		url: `common/areaCascaderList`,
	})
}


//获取个人信息
export function userInfo() {
	return request({
		method: 'get',
		url: `user/info/get`,
	})
}

//开启课堂助手
export function courseOpenHelper(techClassHelperId) {
	return request({
		method: 'post',
		url: `tech/class/course/openHelper?techClassHelperId=${techClassHelperId}`,
	})
}

//保存会话的提示词
export function courseBindingHelper(data) {
	return request({
		method: 'post',
		url: `tech/class/course/bindingHelper`,
		data
	})
}

//保存会话的提示词
export function saveSessionPrompt(data) {
	return request({
		method: 'post',
		url: `promptHelper/saveSessionPrompt`,
		data
	})
}

//根据助手ID和属性值获取对应提示词
export function promptInfo(data) {
	return request({
		method: 'post',
		url: `promptHelper/getPrompt`,
		data
	})
}

//根据助手ID和选中属性值获取下一个属性的选项
export function nextPromptOption(data) {
	return request({
		method: 'post',
		url: `promptHelper/getNextPromptOption`,
		data
	})
}

//获取助手详情
export function helperInfo(id) {
	return request({
		method: 'get',
		url: `helper/get/${id}`,
	})
}

//每次进入助手创建会话
export function createSession(helperId) {
	return request({
		method: 'post',
		url: `promptHelper/createSession?helperId=${helperId}`,
	})
}

//获取预置流程助手（不包括通用助手）
export function listAllAgent(type) {
	return request({
		method: 'get',
		url: `helper/listAllAgent?type=${type}`,
	})
}

//获取助手根据labelId
export function helperLabelId(labelId) {
	return request({
		method: 'get',
		url: `helper/listByLabelId?labelId=${labelId}`,
	})
}

//获取所有助手（不包括通用助手）
export function helperListAll(type) {
	return request({
		method: 'get',
		url: `helper/listAll?type=${type}`,
	})
}

export function fileList() {
	return request({
		method: 'get',
		url: `tech/class/course/getInfoFileList?pageNum=1&pageSize=100`,
	})
}

//
export function queryEvaluateStatus(techClassHelperId) {
	return request({
		method: 'get',
		url: `tech/class/course/queryEvaluateStatus?techClassHelperId=${techClassHelperId}`,
	})
}


//保存原文文件到个人资源库
export function transRecordSaveTransFile(id) {
	return request({
		method: 'post',
		url: `trans/transRecord/saveTransFile?id=${id}`,
	})
}

//获取同声传译原文文件地址(保存/分享文件前,获取文件地址)
export function transRecordTransFilePath(id) {
	return request({
		method: 'get',
		url: `trans/transRecord/getTransFilePath?id=${id}`,
	})
}

//保存文件到个人资源库
export function transRecordSaveFile(id) {
	return request({
		method: 'post',
		url: `trans/transRecord/saveFile?id=${id}`,
	})
}

//获取同声传译文件地址(保存/分享文件前,获取文件地址)
export function transRecordFilePath(id) {
	return request({
		method: 'get',
		url: `trans/transRecord/getFilePath?id=${id}`,
	})
}

//获取同声传译分析结果
export function transRecordAnalysis(id) {
	return request({
		method: 'get',
		url: `trans/transRecord/getAnalysis?id=${id}`,
	})
}

//获取同声传译原文
export function transRecordContent(id) {
	return request({
		method: 'post',
		url: `trans/transRecord/getContent?id=${id}`,
	})
}

//获取同声传译状态 状态 1-录音中 2-生成文件中 3-完成
export function transRecordStatus(id) {
	return request({
		method: 'post',
		url: `trans/transRecord/getStatus?id=${id}`,
	})
}

//获取同声传译历史记录
export function transRecordList(pageNum) {
	return request({
		method: 'get',
		url: `trans/transRecord/getList?pageNum=${pageNum}&pageSize=${20}`
	})
}

//保存同声传译
export function transRecordSave(data) {
	return request({
		method: 'post',
		url: `trans/transRecord/save`,
		data
	})
}

//加入班级
export function classJoin(mihuaNo) {
	return request({
		method: 'get',
		url: `tech/class/join?mihuaNo=${mihuaNo}`
	})
}

//获取任教学段和科目下拉列表
export function sectionSubject(type) {
	return request({
		method: 'get',
		url: `tech/sectionSubject/list/${type}`
	})
}


//创建班级
export function classCreate(data) {
	return request({
		method: 'post',
		url: `tech/class/create`,
		data
	})
}

//导入学生头像
export function importStudentAvatarData(data) {
	return request({
		method: 'post',
		url: `tech/class/student/importStudentAvatarData`,
		data
	})
}

//修改班级学生
export function studentUpdate(data) {
	return request({
		method: 'post',
		url: `tech/class/student/update`,
		data
	})
}

//获取班级学生详情
export function studentInfo(id) {
	return request({
		method: 'get',
		url: `tech/class/student/get/${id}`
	})
}

//获取导入学生模板
export function importTemplate() {
	return request({
		method: 'post',
		url: `tech/class/student/importTemplate`
	})
}


//导入班级学生
export function importStudentData(data) {
	return request({
		method: 'post',
		url: `tech/class/student/importStudentData`,
		data
	})
}

//新增班级学生
export function classStudentAdd(data) {
	return request({
		method: 'post',
		url: `tech/class/student/add`,
		data
	})
}


//学生详情
export function techClassHelperStudent(studentId,techClassHelperId,userId) {
	return request({
		method: 'get',
		url: `tech/class/course/getTechClassHelperStudent?studentId=${studentId}&techClassHelperId=${techClassHelperId}&userId=${userId?userId:''}`,
	})
}

//每次进入助手创建会话
export function universalCreateSession() {
	return request({
		method: 'post',
		url: `universalHelper/createSession`,
	})
}

//获取阿里云信息
export function ossToken(fileName) {
	return request({
		method: 'get',
		url: `upload/getOssToken?model=qimiyun&pid=0&fileName=${fileName}`
	})
}

//课堂删除
export function courseRemove(id) {
	return request({
		method: 'get',
		url: `tech/class/course/remove?id=${id}`,
	})
}

//课堂修改
export function courseEdit(data) {
	return request({
		method: 'post',
		url: `tech/class/course/edit`,
		data
	})
}


//统计分析数据
export function courseStatisticalAnalysis(data,techCourseId,studentId,userId) {
	return request({
		method: 'post',
		url: `tech/class/course/statisticalAnalysis?techCourseId=${techCourseId}&studentId=${studentId?studentId:''}&userId=${userId?userId:''}`,
		data
	})
}

//下课
export function finishTechClassCourse(id) {
	return request({
		method: 'get',
		url: `tech/class/course/finishTechClassCourse?id=${id}`,
	})
}

//开始上课
export function startTechClassCourse(id) {
	return request({
		method: 'get',
		url: `tech/class/course/startTechClassCourse?id=${id}`,
	})
}


//智能体详情
export function classHelperDetail(techClassHelperId) {
	return request({
		method: 'get',
		url: `tech/class/course/classHelperDetail?techClassHelperId=${techClassHelperId}`,
	})
}

//智能体开始/结束
export function updateTechClassHelperStatus(status,techClassHelperId) {
	return request({
		method: 'get',
		url: `tech/class/course/updateTechClassHelperStatus?status=${status}&techClassHelperId=${techClassHelperId}`,
	})
}

//课堂助手学生列表
export function courseStuList(techClassHelperId) {
	return request({
		method: 'get',
		url: `tech/class/course/stuList?techClassHelperId=${techClassHelperId}`,
	})
}

//课堂助手对应学生对话列表
export function courseStuMsgList(studentId,techClassHelperId,userId) {
	return request({
		method: 'get',
		url: `tech/class/course/getMsgList?studentId=${studentId}&techClassHelperId=${techClassHelperId}&userId=${userId?userId:''}`,
	})
}

//课堂信息
export function courseInfo(id) {
	return request({
		method: 'get',
		url: `tech/class/course/getInfo?id=${id}`,
	})
}

//查询班级智能体关联列表
export function courseHelperList(techCourseId) {
	return request({
		method: 'get',
		url: `tech/class/course/courseHelperList?techCourseId=${techCourseId}`,
	})
}

//课堂详情
export function courseDetail(id) {
	return request({
		method: 'get',
		url: `tech/class/course/detail?id=${id}`,
	})
}

//课堂智能体选择列表
export function techHelperOption(courseType,techCourseId) {
	return request({
		method: 'get',
		url: `tech/class/course/techHelperOption?courseType=${courseType}&techCourseId=${techCourseId||''}`,
	})
}

//课堂新增
export function courseAdd(data) {
	return request({
		method: 'post',
		url: `tech/class/course/add`,
		data
	})
}


//查询班级课堂列表
export function classCourseList(techClassId,pageNum,courseType,isTeacher) {
	return request({
		method: 'get',
		url: `tech/class/course/list?techClassId=${techClassId}&pageNum=${pageNum}&pageSize=${20}&courseType=${courseType||''}&isTeacher=${isTeacher==1?true:false}`,
	})
}

//获取班级学生列表
export function classStudentList(classId) {
	return request({
		method: 'get',
		url: `tech/class/student/list/${classId}`,
	})
}


//校验当前老师是否有班主任权限
export function checkPermi(classId) {
	return request({
		method: 'get',
		url: `tech/class/checkPermi/${classId}`,
	})
}

//获取班级设置  班级详情
export function classInfo(classId) {
	return request({
		method: 'get',
		url: `tech/class/get/${classId}`,
	})
}

//获取我的班级列表
export function myClassList(showFlag,isTeacher,classType) {
	console.log(isTeacher,'isTeacher',showFlag);
	return request({
		method: 'get',
		url: `tech/class/listMy?showFlag=${showFlag?showFlag:''}&isTeacher=${isTeacher==1?true:false}&classType=${classType||''}`,
	})
}

//发送短信验证码
export function sendCode(type, phone) {
	return request({
		method: 'post',
		url: `user/login/sendCode?type=${type}&phone=${phone}`,
	})
}

//手机号短信验证码登录
export function codeLogin(data) {
	return request({
		method: 'post',
		url: `user/login/codeLogin`,
		data
	})
}


